import React from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {warnOnce} from 'graphql-client/warnOnce';
import ReviewConstants from 'notebook/reviews/ReviewConstants';
import {AssayRecordOrigin} from 'results/assays/__generated/AssayRecordOrigin';
import {
  ASSAY_RECORD_ORIGIN_LINK_QUERY,
  getAssayRecordOriginFromCache,
} from 'results/assays/AssayRecordOriginLink';

import {
  GetAssayRecordOriginLink,
  GetAssayRecordOriginLinkVariables,
} from './__generated/GetAssayRecordOriginLink';

function _getReviewStatusTextFromOrigin(origin: AssayRecordOrigin): string {
  const entry = origin.elnOrigin.entry;
  return entry && entry.review && entry.review.status === ReviewConstants.ACCEPTED ? 'Yes' : 'No';
}

export function getReviewStatusText(resultId: string): string {
  const origin = getAssayRecordOriginFromCache(resultId);
  if (origin) {
    return _getReviewStatusTextFromOrigin(origin);
  }
  return 'Loading...';
}

const LOADING_TEXT = 'Loading...';

function ReviewStatusDisplay({resultId}: {resultId: string}): JSX.Element {
  return (
    <BenchlingQuery<GetAssayRecordOriginLink, GetAssayRecordOriginLinkVariables>
      query={ASSAY_RECORD_ORIGIN_LINK_QUERY}
      variables={{resultId}}
      renderLoading={() => LOADING_TEXT}
    >
      {(data) => {
        if (isInaccessible(data.result)) {
          warnOnce('Did not expect inaccessible item.');
          return null;
        } else {
          const origin = data.result.origin;
          return <span>{_getReviewStatusTextFromOrigin(origin)}</span>;
        }
      }}
    </BenchlingQuery>
  );
}

export default ReviewStatusDisplay;
